import { render, staticRenderFns } from "./CbsDomain.vue?vue&type=template&id=50e579d1&scoped=true"
import script from "./CbsDomain.vue?vue&type=script&lang=js"
export * from "./CbsDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e579d1",
  null
  
)

export default component.exports